import { useState } from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import LookupChip from "./LookupChip";
import { useLookupColorMaps } from "../hooks/useLookups";

export default function InitiativeCard({
  initiative,
  onClick,
  draggable = true,
}) {
  const { statusColors, priorityColors } = useLookupColorMaps();
  const [isHovered, setIsHovered] = useState(false);

  const handleDragStart = (event) => {
    event.dataTransfer.setData("text/plain", String(initiative.id));
    event.dataTransfer.effectAllowed = "move";
  };

  const styles = {
    card: {
      p: 1.5,
      cursor: "pointer",
      bgcolor: "background.cardBackground",
      transition: "box-shadow 0.15s ease, transform 0.15s ease",
      ...(isHovered && { boxShadow: 6, transform: "translateY(-2px)" }),
    },
    archivedCard: { opacity: 0.6 },
    title: {
      fontWeight: 600,
      mb: 0.5,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    owner: {
      color: "background.textMuted",
      mb: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    chipsRow: { display: "flex", gap: 0.5, flexWrap: "wrap", mb: 1 },
    productRow: { display: "flex", gap: 0.5, flexWrap: "wrap" },
  };

  return (
    <Paper
      elevation={1}
      draggable={draggable}
      onDragStart={draggable ? handleDragStart : undefined}
      onDragEnd={draggable ? () => setIsHovered(false) : undefined}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onClick(initiative)}
      sx={[styles.card, initiative.archived ? styles.archivedCard : null]}
    >
      <Typography variant="subtitle2" sx={styles.title}>
        {initiative.title}
      </Typography>
      <Typography variant="caption" component="div" sx={styles.owner}>
        {initiative.owner}
      </Typography>
      <Box sx={styles.chipsRow}>
        <LookupChip
          label={initiative.status}
          hex={statusColors[initiative.status]}
        />
        <LookupChip
          label={initiative.priority}
          hex={priorityColors[initiative.priority]}
          variant="outlined"
        />
        {initiative.archived && (
          <Chip label="Archived" size="small" color="archived" />
        )}
      </Box>
      {initiative.product?.length > 0 && (
        <Box sx={styles.productRow}>
          {initiative.product.map((product) => (
            <LookupChip key={product} label={product} variant="outlined" />
          ))}
        </Box>
      )}
    </Paper>
  );
}
